import { render, staticRenderFns } from "./teamreg.vue?vue&type=template&id=663d9698&scoped=true"
import script from "./teamreg.vue?vue&type=script&lang=js"
export * from "./teamreg.vue?vue&type=script&lang=js"
import style0 from "./teamreg.vue?vue&type=style&index=0&id=663d9698&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663d9698",
  null
  
)

export default component.exports